































































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { uuid } from '@/util/uuid';
@Component({
  components: {},
})
export default class ContactWay extends Vue {
  @Prop(Number) unitId: any;
  @Prop() private formProp: any;
  private dataText: any = '123123';
  private drawer = false;

  private form: any = {};
  mounted() {
    if (JSON.stringify(this.formProp) == '{}') {
      this.form = {
        id: uuid(),
        label: '手机号码输入框',
        placeholder: '请输入手机号码',
        required: true,
      };
      this.$nextTick(() => {
        this.$emit('unit_set_data', { id: this.unitId, form: this.form });
      });
    } else {
      this.form = this.formProp;
    }
    console.log(this.form);
  }

  closeTap() {
    console.log(this.unitId);
    this.$emit('i_close', { id: this.unitId });
  }

  beforeClose(done: any) {
    this.$emit('unit_set_data', { id: this.unitId, form: this.form });
    done();
  }
}
